import * as React from 'react'
import styled from 'styled-components'

import * as S from '../styles'

export type PlaceholderProps = React.HTMLAttributes<HTMLLabelElement> & {
  className?: string
  clickTarget?: string
}

function PlaceholderComponent({
  children,
  clickTarget,
  className,
  ...rest
}: PlaceholderProps): React.ReactElement<any> {
  return (
    <S.placeholder.Label className={className} htmlFor={clickTarget} {...rest}>
      {children}
    </S.placeholder.Label>
  )
}

export const Placeholder = styled(PlaceholderComponent)``
